// BARRE DE RECHERCHE
const filterButtons = document.querySelectorAll('.filter__button');

// FILTRES 
let filters = document.querySelectorAll('.filters-list');
console.log(filters);

filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
        if (button.classList.contains('filter__button--opened')) {
            button.classList.remove('filter__button--opened');
            button.setAttribute('aria-expanded', 'false');
        } else {
            button.classList.add('filter__button--opened');
            button.setAttribute('aria-expanded', 'true');
        }
    });
    if(window.matchMedia("(max-width:991px)").matches) {
        filters.forEach((filter) => {
            filter.addEventListener('click', () => {
                button.classList.remove('filter__button--opened');
                button.setAttribute('aria-expanded', 'false');
            });
        });
    }
});
